import apiClient from '@/api/apiClient'

export const getMonitoring = (accountId, params = {}) =>
  apiClient.get(`api/v1/accounts/${accountId}/monitoring`, { params })

export const getLostThreads = (accountId, params = {}) =>
  apiClient.get(`api/v1/accounts/${accountId}/monitoring/lost`, { params })
